import { forwardRef, PropsWithChildren } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

import { Theme } from '@bizzabo/design-system';

export type UserInfoContainerProps = {
    containerClass?: string;
    onClick?: () => void;
};

const UserInfoContainer = forwardRef<HTMLDivElement, PropsWithChildren<UserInfoContainerProps>>(
    ({ containerClass, onClick = () => {}, children }, ref) => {
        const classes = useStyles();

        return (
            <div
                className={clsx(classes.container, containerClass)}
                role="dialog"
                ref={ref}
                data-nocollapse="profile-card"
                onClick={onClick}
            >
                {children}
            </div>
        );
    }
);

UserInfoContainer.displayName = 'UserInfoContainer';

const useStyles = makeStyles<Theme>(
    theme => ({
        container: {
            position: 'relative',
            backgroundColor: theme.palette.greys[100],
            borderRadius: 29,
            padding: 16,
            width: 276,
            gridColumn: 'span 1',
            fontFamily: theme.typography.t30.fontFamily,
            boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.1)',
        },
    }),
    { classNamePrefix: 'people-user-info-container' }
);

export default UserInfoContainer;
